export { default as defaultTheme } from './default'
export { default as classicTheme } from './classic'
export { default as deprecatedDefaultTheme } from './deprecated'
